import setAlign from './setAlign';

/**
 * Set align items attribute to node's Yoga instance
 *
 * @param {String} align value
 * @param {Object} node instance
 * @return {Object} node instance
 */
const setAlignItems = setAlign('items');

export default setAlignItems;
